export default __webpack_public_path__ + "static/media/apps.cbb98009.png";